import { Analytics } from "@mui/icons-material";

export let baseurl = "/digitalportfolio2";
export let appVersion = 'Digital Portfolio';

// export const appENV = "local";
// export const appENV = "sit"; // "sit" for SIT Environment
export const appENV = "uat"; // "uat" for UAT & PROD environment

export const checkENV = "local";
export const uatENV = "uat";
// export let baseurlLink = "https://portfolio.nie.edu.sg/digitalportfolio2";
if (process.env.REACT_APP_API_BASE) {
  baseurl = process.env.REACT_APP_API_BASE;
}

if (process.env.REACT_APP_VERNUM) {
  appVersion += ' ' + process.env.REACT_APP_VERNUM;
}

export let baseurlLink = appENV === uatENV ? "https://portfolio.nie.edu.sg/digitalportfolio2" : baseurl;

/*Live*/
export const apiUrl = baseurl + "/ppi/apiv1/v1/";
export const apiUrl2 = baseurl + "/ppi/apiv1/v2/";
export const apiUrl3 = baseurl + "/ppi/apiv1/v3/";
export const apiMainUrl = baseurl + "/ppi/";
export const apiadminUrl = baseurl + "/ppi/api/admin/v1/";
export const clientId = "682695389274-8md94unosb58m0f95k0lvfnu0qd133fj.apps.googleusercontent.com";
export const uploadpath = baseurl + "/ppi/uploads/";
//newppikey(7.4.2020)
export const apiKey = "AIzaSyA4cGd45aICwAxLpMwg9g5vDvwn9YF44EE";
export const developerKey = "AIzaSyArbgVXzgLxTs2jfTlvR2CA0O6S-3MUOdA";
export const scope = [
  "https://www.googleapis.com/auth/drive",
  "https://www.googleapis.com/auth/drive.file",
  "https://www.googleapis.com/auth/drive.metadata",
  "https://www.googleapis.com/auth/drive.appdata",
];
export const loginUrl = baseurl + "/ppi/sso";
export const loginLocal = baseurl + "/v2/ppi/sso";
export const logout = "https://nieclm.nie.edu.sg/clm/logout.jsp";
export const redirecturl =
  "https://www.google.com/a/g.nie.edu.sg/ServiceLogin?continue=https://sites.google.com/a/g.nie.edu.sg/ppi-portal/";

export const googleApiKey = "AIzaSyAY2jkSWLuXmTltSC6q1CfTCMdGLvphKSY"; // "AIzaSyCvgSJleoUefav49SHCS6msQ7AXVWu4nvk";
// export const googleClientId = "918562411813-s53fsoqdoedk96q5grs0mdd72icih17o.apps.googleusercontent.com";
// export const googleClientId = "343019821955-gdka5tac6amjmvrkq940srmhi3dfd740.apps.googleusercontent.com";
export const googleClientId = "682695389274-8md94unosb58m0f95k0lvfnu0qd133fj.apps.googleusercontent.com";

export const apiheaders = {
  /*"Content-Type": "application/x-www-form-urlencoded"*/
};
export const limitsize = "10";
export const limitsizeArtifacts = "24";

const DP_ROOT = appENV === checkENV ? '' : '/digitalportfolio2';
//const DP_ROOT = '';

export const getUrl = (path) => {
  return DP_ROOT + path;
}

//const termsAndCondition = appENV === uatENV ? baseurlLink + "/ppi/api/admin/v1/login_page" : "http://40.114.7.171:8000/digitalportfolio2/ppi/api/admin/v1/login_page";
const termsAndCondition = appENV === uatENV ? baseurlLink + "/ppi/api/admin/v1/login_page?replace=true" : "http://nie-digitalportfolio.eastus.cloudapp.azure.com:8000/digitalportfolio2/ppi/api/admin/v1/login_page?replace=true";
// const termsAndCondition = baseurlLink + "/ppi/api/admin/v1/login_page";

export const filesUrl = appENV === uatENV ? baseurlLink + "/ppi/" : "http://40.114.7.171:8000/digitalportfolio2/ppi/";
// export const filesUrl = baseurlLink + "/ppi/";

export const apiAuthorizeKey = '0031264009442932';

export const serverUrl = {
  Base: baseurl + "/ppi/",

  Login: apiUrl + "login",
  Logout: apiUrl + "user/logout",
  LoginGoogle: apiUrl + "login/google",
  LoginGuest: apiUrl + "login/guest",
  LoadUser: apiUrl + "profile",
  LoadUser1: apiUrl2 + "profile",
  LoadUserId: apiUrl + "viewprofile",
  LoadUserId2: apiUrl2 + "viewprofile",
  LoadGuestUser: apiUrl + "users/profile",

  GuestShowcase: apiUrl + "users/showcase",

  ProfileUpdateEmail: apiUrl + "profileupdate/email",
  ProfileAvatar: apiUrl + "upload/avatar",
  ProfileCover: apiUrl + "upload/cover",
  ProfilePinnedImage: apiUrl + "upload/pinnedimage",

  Showcase: apiUrl + "showcase",
  Showcase2: apiUrl + "showcase_name",
  ShowcaseDetails: apiUrl + "showcase-details",
  GetDPStatistics: apiUrl + "dpstatistics",

  ShowcaseUser: apiUrl + "showcase/user",
  ShowcaseUser2: apiUrl2 + "showcase/user",
  ShowcaseUserDetails: apiUrl + "showcase-details/user",
  ShowcaseReorder: apiUrl + "showcase/update_sort_order",
  ShowcaseUserDetails2: apiUrl2 + "showcase-details/user",

  ShowcasePost: apiUrl + "showcasereflection",
  ShowcaseAccess: apiUrl + "showcaseaccess",

  ExportShowcasePdf: apiUrl + "showcase/generatepdf",
  ExportShowcaseHtml: apiUrl + "showcase/generatehtml",
  ExportPostPdf: apiUrl + "posts/export",
  ExportPostHtml: apiUrl + "posts/export_html",

  GenerateLink: apiUrl + "showcase/gen/protected_access",

  Post: apiUrl + "posts",
  Comment: apiUrl + "comments",
  Comment2: apiUrl2 + "comments",
  UploadFile: apiUrl + "uploadfile",
  UploadMultipleFiles: apiUrl + "uploadmultiplefile",
  UploadImage: apiUrl + "upload/image",
  UploadBase64: apiUrl + "upload/base64",

  Artefacts: apiUrl + "artefacts",

  Reflections: apiUrl + "posts",
  ReflectionPost: apiUrl + "reflection",
  ReflectionGroups: apiUrl + "posts",
  User: apiUrl + "user",
  User2: apiUrl2 + "user",

  GuestReflectionPost: apiUrl + "reflections/user",

  Teaching: apiUrl + "task/teaching",
  Teaching2: apiUrl2 + "task/teaching",
  TeachingCourses: apiUrl + "task/teaching/courses",
  TeachingCourse: apiUrl + "task/teaching/course",
  TeachingDownload: apiUrl + "task/teaching/export/studentlist",
  TeachingDownloadZip: apiUrl + "task/teaching/export/task",
  TeachingTaskVerify: apiUrl + "task/teaching/verify/task",
  TeachingNotification: apiUrl + "task/teaching/notification",
  TeachingTasklistPin: apiUrl + "task_list/pin",
  TeachingTasklistArchive: apiUrl + "task_list/archive",
  Task: apiUrl + "tutor_profile",

  Learning: apiUrl + "task/learning",
  LearningCourses: apiUrl + "task/learning/courses",
  LearningResponse: apiUrl + "task/learning/response",
  LearningMyTask: apiUrl + "task/mylearning",

  Community: apiUrl + 'community',
  Communityv2: apiUrl2 + 'community',
  CommunityGroups: apiUrl2 + 'community/groups',
  CommunityGroupsv3: apiUrl3 + 'community/groups',
  CommunityGroupsImages: apiUrl + 'community/get_card_image/',
  CommunityGroupsMembers: apiUrl + 'community/group_member/',
  CommunityPersonal: apiUrl + 'community/personal',
  CommunityGroup: apiUrl + 'community/group',
  CommunityGroupv2: apiUrl2 + 'community/group',
  CommunityShared: apiUrl + 'community/shared_to_me',


  ShowCaseReorder: apiUrl + "showcase",

  courses: apiUrl + "courses",
  events: apiUrl + "events",
  values: apiUrl + "values",

  courses2: apiUrl2 + "courses",
  events2: apiUrl2 + "events",
  values2: apiUrl2 + "values",

  GetMenus: apiUrl + "menu",
  GetMenus2: apiUrl2 + "menu",
  GetCommunitySubMenu: apiUrl + "community_menu/",
  VerifyWhitelist: apiUrl + "user/secondaryemail/verify",

  GetVideos: apiUrl + "videos",
  // GetVbeLists: apiUrl + "vbe_module",
  GetVbeLists: apiUrl + "vbe_menu_item",
  GetVbeLists2: apiUrl2 + "vbe_menu_item",
  // GetAnalyticsMenuList: apiUrl + "analytics_menu_item",

  //New API's
  EditProfile: termsAndCondition,
  sharedPosts: apiUrl + "shared_posts",
  sharedPost: apiUrl + "shared_post",
  CommunitySharePost: apiUrl + "community_share_post",
  UserSharePost: apiUrl + "user_share_post",
  SharedToOthers: apiUrl + "community/shared_to_others",
  SharedInCommunity: apiUrl + "community/shared_in_community",
  SharedToFilter: apiUrl + "community/shared_filter",
  SharedToOthersFilter: apiUrl + "community/shared_others_filter",
  SharedToGroupFilter: apiUrl + "community/shared_group_filter",
  UnshareUser: apiUrl + "unshare_user_post",
  UnshareGroup: apiUrl + "unshare_group_post",

  Pinned_Reflection: apiUrl + "pinnedreflection",
  GroupCardImage: apiUrl + "community/group_card_image/",
  SharedCommentCount: apiUrl + "community/shared_ref_count",

  GetUserPreferences: apiUrl + "user_page_preferences",
  ActionUserPreference: apiUrl + "user_page_preference",
  ActionCompentencyStatus: apiUrl + "showcase/competency/",

  ShowcaseGalleryGroup: apiUrl + "showcase_gallery/groups",
  ShowcaseGalleryImage: apiUrl + "showcase_gallery/image/",
  ShowcaseGallery: apiUrl + "showcase_gallery",
  ActionDuplicateTask: apiUrl + "task_list/duplicate",
  putSystemTheme: apiUrl2 + "user/theme/",
  GetLikesMembers: apiUrl + "likes",
  showcaseExport: apiUrl + "export_settings",
  showcaseExportTutor: apiUrl + "export_assignment_settings",

  Map: apiUrl + "map/",

  //Phase 1
  ReflectionFeedBackModels: apiUrl + "feedback_models",
  ReflectionFeedbackPollGroups: apiUrl + "feedback_models/pollgroups",
  ReflectionFeedBack: apiUrl + "reflection_feedback",
  ReflectionFeedBackHistory: apiUrl + "reflection_feedback_history",
  ExportReflectionFeedBackHistory: apiUrl + "export_feedback_history",
  ReflectionExport: apiUrl + "reflection_export",
  ReflectionPollResponse: apiUrl + "pollresponse",
  ReflectionExportWord: apiUrl + "reflection_export_docx",
  ReflectionAutoSave: apiUrl + "autosave_duration",

  //Phase 2 Sprint 2
  ChatBotResponse: apiUrl + "chatbot/generate_response",
  ChatBotStopResponse: apiUrl + "chatbot/stop_response",
  ChatBotResponseDownload: apiUrl + "chatbot/download_chat",
  ChatBotSession: apiUrl + "chatbot/session_details",
  ChatBotCloseSession: apiUrl + "chatbot/close_session",
  ChatBotDetails: apiUrl + "chatbot/details",

  //Analytics
  AnalyticsGenericCard: apiUrl + "analytics/generic/cards",
  AnalyticsGenericCharts: apiUrl + "analytics/generic/charts",
  AnalyticsGenericReflectionYearCharts: apiUrl + "analytics/generic/reflection_by_year",
  AnalyticsGenericReflectionYearValueCharts: apiUrl + "analytics/generic/year_values",
  AnalyticsSocialCards: apiUrl + "analytics/social/cards",

  AnalyticsCompetencyCards: apiUrl + "analytics/competency/cards",
  AnalyticsCompetencyGroups: apiUrl + "analytics/competency/groups",
  AnalyticsSocialReflectionLikesMembers: apiUrl + "analytics/social/reflection_likes/users?reflection_id=",
  AnalyticsSocialReflectionReadsMembers: apiUrl + "analytics/social/reflection_reads/users?reflection_id=",
  ReflectionsReads: apiUrl + "reflection/reflection_read",

  AnalyticsModuleCardDetails: apiUrl + "analytics/card_details",

  //Switch Learner Profile
  LearnerProfiles: apiUrl + "learner_profiles/",
  SwitchProfile: apiUrl + "switch_profile",
  SettingsAnalyticsToggle: apiUrl + "settings_analytics_toggle",

  // Attachments limitations
  AttachmentsLimit: apiUrl + "attachment_settings",
  ProfileSettings: apiUrl + "profile_settings",
  ShowcaseCards: apiUrl + "showcase/cards",

  CommunityFeed: apiUrl + "community/feed/sidebar_filters",
};

